// extracted by mini-css-extract-plugin
export var active = "_27-9";
export var backButton = "_27-8";
export var clone = "_27-e";
export var collapseBar = "_27-j";
export var collapseMode = "_27-l";
export var collapsed = "_27-n";
export var dragHandle = "_27-c";
export var dropdownIcon = "_27-g";
export var expanding = "_27-m";
export var hidden = "_27-w";
export var iconContainer = "_27-p";
export var iconSwapper = "_27-v";
export var navItem = "_27-6";
export var navItemIcon = "_27-f";
export var navProfile = "_27-7";
export var notificationCountBadge = "_27-i";
export var notificationDot = "_27-q";
export var optionsContainer = "_27-h";
export var primaryNav = "_27-0";
export var primaryNavDivider = "_27-u";
export var primaryNavResizeHandle = "_27-2";
export var primaryNavResizing = "_27-1";
export var primaryNavTabSection = "_27-t";
export var primaryTab = "_27-o";
export var primaryTabIconBox = "_27-r";
export var secondaryNav = "_27-3";
export var selected = "_27-s";
export var settingsNav = "_27-4";
export var settingsNavItems = "_27-5";
export var show = "_27-d";
export var sideNav = "_27-k";
export var teamItem = "_27-a";
export var userProfileItem = "_27-b";